/**
 * @description 新的点赞接口
 * @author duanjun
 */

import Api from '../../../path'
import { fetchData } from '@umu/umu-fetch';
import { CommentParentType } from '@umu/umu-types';

export enum LikeType {
    Like = 'like', // like点赞 cancel_like取消点赞 unlike点踩 cancel_unlike取消点赞
    CancelLike = 'cancel_like',
    UnLike = 'unlike',
    CancelUnlike = 'cancel_unlike',
}

interface IInput {
    action: LikeType;
    obj_type: CommentParentType;
    obj_id: number;
}

interface IOutput {
    result: boolean;
}

export const like = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.LIKE, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
